import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=d9a45396&scoped=true&"
import script from "./base_info.vue?vue&type=script&lang=js&"
export * from "./base_info.vue?vue&type=script&lang=js&"
import style0 from "./base_info.vue?vue&type=style&index=0&id=d9a45396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a45396",
  null
  
)

export default component.exports